import { gql } from "@apollo/client";

const Fragments = {
  quote: gql`
    fragment quote on Quote {
      quoteId
      transactionId
      estimationName
      isEstimation
      quoteStatusId
      quoteStatusCode
      quoteStatusName
      dealerId
      vendorId
      partnerId
      partnerTypeId
      quoteHeaderPartnerName
      legalFormName
      ownerName
      street
      city
      district
      zipCode
      country
      phone
      partnerUniqueId
      showAmountsWithVAT
      currencyId
      currencyCode
      totalAmount
      totalAmountWithVAT
      totalAssetNetPrice
      totalAssetNetPriceWithVAT
      totalAdditionalCosts
      downPayment
      period
      assetNo
      downPayment
      period
      exchangeRate
      exchangeRateDate
      contactInfoId
      offerNotes
      folderId
      zootDocDecisionFinished
      zootDocDecisionColor
      zootDocDecisionReasons
      rating
    }
  `,
  quoteProduct: gql`
    fragment quoteProduct on QuoteProduct {
      quoteProductId
      quoteId
      selected
      productId
      productCode
      productName
      productTypeId
      productTypeCode
      productTypeName
      translatedProductDescription
      duration
      durationString
      scheduleIsConfigurable
      downPaymentAmount
      downPaymentAmountWithVAT
      useRentalDownPayment
      rentalDownPaymentAmount
      residualValueVisible
      residualValueAmount
      residualValueAmountWithVAT
      hasSchedule
      scheduleTypeId
      minDuration
      maxDuration
      periodicity
      paymentFrequency
      downPaymentUsePercent
      downPaymentPercent
      downPaymentMinPercent
      downPaymentMaxPercent
      residualValueUsePercent
      residualValuePercent
      residualValueDefaultPercent
      residualValueMinPercent
      residualValueMaxPercent
      residualValueIsReadonly
      vatRate
      useVatFinancing
      vatFinancing
      totalAmount
      totalAmountWithVAT
      financedAmount
      financedAmountWithVAT
      showAmountsWithVAT
      canAddInsurance
      addInsurance
      dealerCommissionIsManual
      dealerCommissionValue
      subsidyValue
      flatRate
      interestTypeId
      interestPercent
      totalInterestPercent
      interestTypeIsFixed
      interestMinPercent
      interestMaxPercent
      floatingInterestPercent
      bankMargin
      bankMargin_PeriodMin
      bankMargin_PeriodMax
      variableInterestDate
      containsBackOfficeChanges
      useInterestInArrears
      finalPurchasePrice
      finalDownPaymentAmount
      financedVatAmount
      savedWithError
      error
      insuranceMessageRequired
      calculateInsuranceMessage
      ratingBasedInterestPercent
      priceCard {
        priceCardId
        rvCalculationId
        rvCalculationCode
      }
    }
  `,
};

export default Fragments;
